"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class SettingsApi extends runtime.BaseAPI {
    /**
     * Adds an analytics extensions connection for an external service to a site. Permissions - This method can be called by site and server administrators.
     * Add analytics extension connection to site
     */
    analyticsExtensionsServiceAddAnalyticsExtensionsConnectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.analyticsextensions.v1.ConnectionItem+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/analytics/connections`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauAnalyticsextensionsV1ConnectionItemToJSON(requestParameters.tableauAnalyticsextensionsV1ConnectionItem),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauAnalyticsextensionsV1ConnectionItemFromJSON(jsonValue));
        });
    }
    /**
     * Adds an analytics extensions connection for an external service to a site. Permissions - This method can be called by site and server administrators.
     * Add analytics extension connection to site
     */
    analyticsExtensionsServiceAddAnalyticsExtensionsConnection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.analyticsExtensionsServiceAddAnalyticsExtensionsConnectionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Deletes a specific analytics extension connection for an external service from a site. Permissions - This method can be called by site and server administrators.
     * Delete analytics extension connection from site
     */
    analyticsExtensionsServiceDeleteAnalyticsExtensionsConnectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.connectionLuid === null || requestParameters.connectionLuid === undefined) {
                throw new runtime.RequiredError('connectionLuid', 'Required parameter requestParameters.connectionLuid was null or undefined when calling analyticsExtensionsServiceDeleteAnalyticsExtensionsConnection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/analytics/connections/{connection_luid}`.replace(`{${"connection_luid"}}`, encodeURIComponent(String(requestParameters.connectionLuid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a specific analytics extension connection for an external service from a site. Permissions - This method can be called by site and server administrators.
     * Delete analytics extension connection from site
     */
    analyticsExtensionsServiceDeleteAnalyticsExtensionsConnection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.analyticsExtensionsServiceDeleteAnalyticsExtensionsConnectionRaw(requestParameters);
        });
    }
    /**
     * Remove the currently used analytics extension connection to an external service  from the specified workbook. The connection remains configured, and is available for further usage by the workbook. Permissions - This method can be called by users with authoring access to the workbook.
     * Remove current analytics extension connection for workbook
     */
    analyticsExtensionsServiceDeleteConnectionFromWorkbookRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.workbookLuid === null || requestParameters.workbookLuid === undefined) {
                throw new runtime.RequiredError('workbookLuid', 'Required parameter requestParameters.workbookLuid was null or undefined when calling analyticsExtensionsServiceDeleteConnectionFromWorkbook.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/analytics/workbooks/{workbook_luid}/selected_connection`.replace(`{${"workbook_luid"}}`, encodeURIComponent(String(requestParameters.workbookLuid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Remove the currently used analytics extension connection to an external service  from the specified workbook. The connection remains configured, and is available for further usage by the workbook. Permissions - This method can be called by users with authoring access to the workbook.
     * Remove current analytics extension connection for workbook
     */
    analyticsExtensionsServiceDeleteConnectionFromWorkbook(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.analyticsExtensionsServiceDeleteConnectionFromWorkbookRaw(requestParameters);
        });
    }
    /**
     * Get the details of a specified analytics extension connection to an external service. Permissions - This method can only be called by users with server or site administrator permissions.
     * Get analytics extension details
     */
    analyticsExtensionsServiceGetAnalyticsExtensionsConnectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.connectionLuid === null || requestParameters.connectionLuid === undefined) {
                throw new runtime.RequiredError('connectionLuid', 'Required parameter requestParameters.connectionLuid was null or undefined when calling analyticsExtensionsServiceGetAnalyticsExtensionsConnection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/analytics/connections/{connection_luid}`.replace(`{${"connection_luid"}}`, encodeURIComponent(String(requestParameters.connectionLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauAnalyticsextensionsV1ConnectionItemFromJSON(jsonValue));
        });
    }
    /**
     * Get the details of a specified analytics extension connection to an external service. Permissions - This method can only be called by users with server or site administrator permissions.
     * Get analytics extension details
     */
    analyticsExtensionsServiceGetAnalyticsExtensionsConnection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.analyticsExtensionsServiceGetAnalyticsExtensionsConnectionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists a site\'s analytics extension connections for external services. Permissions- This method can be called by site and server administrators.
     * List analytics extension connections on site
     */
    analyticsExtensionsServiceGetAnalyticsExtensionsConnectionsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/analytics/connections`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauAnalyticsextensionsV1ConnectionListFromJSON(jsonValue));
        });
    }
    /**
     * Lists a site\'s analytics extension connections for external services. Permissions- This method can be called by site and server administrators.
     * List analytics extension connections on site
     */
    analyticsExtensionsServiceGetAnalyticsExtensionsConnections(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.analyticsExtensionsServiceGetAnalyticsExtensionsConnectionsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Gets the enabled/disabled state of analytics extensions on a server. Permissions - This method can only be called by server administrators.
     * Get enabled state of analytics extensions on server
     */
    analyticsExtensionsServiceGetAnalyticsExtensionsServerSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/server/extensions/analytics`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauAnalyticsextensionsV1ServerSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Gets the enabled/disabled state of analytics extensions on a server. Permissions - This method can only be called by server administrators.
     * Get enabled state of analytics extensions on server
     */
    analyticsExtensionsServiceGetAnalyticsExtensionsServerSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.analyticsExtensionsServiceGetAnalyticsExtensionsServerSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Gets the enabled/disabled state of analytics extensions on a site. Permissions - This method can be called by site and server administrators.
     * Get enabled state of analytics extensions on site
     */
    analyticsExtensionsServiceGetAnalyticsExtensionsSiteSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/analytics`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauAnalyticsextensionsV1SiteSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Gets the enabled/disabled state of analytics extensions on a site. Permissions - This method can be called by site and server administrators.
     * Get enabled state of analytics extensions on site
     */
    analyticsExtensionsServiceGetAnalyticsExtensionsSiteSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.analyticsExtensionsServiceGetAnalyticsExtensionsSiteSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists basic details of each analytics extension connection available for a specified workbook, including connection type and name. Permissions - This method can be called by users that have permissions to the specified workbook.
     * List analytics extension connections of workbook
     */
    analyticsExtensionsServiceGetConnectionOptionsForWorkbookRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.workbookLuid === null || requestParameters.workbookLuid === undefined) {
                throw new runtime.RequiredError('workbookLuid', 'Required parameter requestParameters.workbookLuid was null or undefined when calling analyticsExtensionsServiceGetConnectionOptionsForWorkbook.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/analytics/workbooks/{workbook_luid}/connections`.replace(`{${"workbook_luid"}}`, encodeURIComponent(String(requestParameters.workbookLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauAnalyticsextensionsV1ConnectionMetadataListFromJSON(jsonValue));
        });
    }
    /**
     * Lists basic details of each analytics extension connection available for a specified workbook, including connection type and name. Permissions - This method can be called by users that have permissions to the specified workbook.
     * List analytics extension connections of workbook
     */
    analyticsExtensionsServiceGetConnectionOptionsForWorkbook(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.analyticsExtensionsServiceGetConnectionOptionsForWorkbookRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Gets basic details, including connection type and name, of the analytics extension connection to an external service that the specified workbook is currently using. Permissions - This method can be called by users with authoring access to the workbook.
     * Get current analytics extension for workbook
     */
    analyticsExtensionsServiceGetSelectedConnectionForWorkbookRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.workbookLuid === null || requestParameters.workbookLuid === undefined) {
                throw new runtime.RequiredError('workbookLuid', 'Required parameter requestParameters.workbookLuid was null or undefined when calling analyticsExtensionsServiceGetSelectedConnectionForWorkbook.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/analytics/workbooks/{workbook_luid}/selected_connection`.replace(`{${"workbook_luid"}}`, encodeURIComponent(String(requestParameters.workbookLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauAnalyticsextensionsV1ConnectionMetadataFromJSON(jsonValue));
        });
    }
    /**
     * Gets basic details, including connection type and name, of the analytics extension connection to an external service that the specified workbook is currently using. Permissions - This method can be called by users with authoring access to the workbook.
     * Get current analytics extension for workbook
     */
    analyticsExtensionsServiceGetSelectedConnectionForWorkbook(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.analyticsExtensionsServiceGetSelectedConnectionForWorkbookRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Updates the details of specified analytics extension connection for an external service to a site. Permissions - This method can be called by site and server administrators.
     * Update analytics extension connection of site
     */
    analyticsExtensionsServiceUpdateAnalyticsExtensionsConnectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.connectionLuid === null || requestParameters.connectionLuid === undefined) {
                throw new runtime.RequiredError('connectionLuid', 'Required parameter requestParameters.connectionLuid was null or undefined when calling analyticsExtensionsServiceUpdateAnalyticsExtensionsConnection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.analyticsextensions.v1.ConnectionItem+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/analytics/connections/{connection_luid}`.replace(`{${"connection_luid"}}`, encodeURIComponent(String(requestParameters.connectionLuid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauAnalyticsextensionsV1ConnectionItemToJSON(requestParameters.tableauAnalyticsextensionsV1ConnectionItem),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauAnalyticsextensionsV1ConnectionItemFromJSON(jsonValue));
        });
    }
    /**
     * Updates the details of specified analytics extension connection for an external service to a site. Permissions - This method can be called by site and server administrators.
     * Update analytics extension connection of site
     */
    analyticsExtensionsServiceUpdateAnalyticsExtensionsConnection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.analyticsExtensionsServiceUpdateAnalyticsExtensionsConnectionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Enables or disables analytics extensions on a server. Permissions - This method can only be called by server administrators.
     * Enable/disable analytics extensions on server
     */
    analyticsExtensionsServiceUpdateAnalyticsExtensionsServerSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.analyticsextensions.v1.ServerSettings+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/server/extensions/analytics`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauAnalyticsextensionsV1ServerSettingsToJSON(requestParameters.tableauAnalyticsextensionsV1ServerSettings),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauAnalyticsextensionsV1ServerSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Enables or disables analytics extensions on a server. Permissions - This method can only be called by server administrators.
     * Enable/disable analytics extensions on server
     */
    analyticsExtensionsServiceUpdateAnalyticsExtensionsServerSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.analyticsExtensionsServiceUpdateAnalyticsExtensionsServerSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Enables or disables analytics extensions on a site. Permissions - This method can be called by site and server administrators.
     * Update enabled state of analytics extensions on site
     */
    analyticsExtensionsServiceUpdateAnalyticsExtensionsSiteSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.analyticsextensions.v1.SiteSettings+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/analytics`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauAnalyticsextensionsV1SiteSettingsToJSON(requestParameters.tableauAnalyticsextensionsV1SiteSettings),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauAnalyticsextensionsV1SiteSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Enables or disables analytics extensions on a site. Permissions - This method can be called by site and server administrators.
     * Update enabled state of analytics extensions on site
     */
    analyticsExtensionsServiceUpdateAnalyticsExtensionsSiteSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.analyticsExtensionsServiceUpdateAnalyticsExtensionsSiteSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Updates the analytics extension connection to external service currently used by a workbook. Permissions - This method can be called by users that have permissions to the specified workbook.
     * Update analytics extension for workbook
     */
    analyticsExtensionsServiceUpdateWorkbookWithConnectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.workbookLuid === null || requestParameters.workbookLuid === undefined) {
                throw new runtime.RequiredError('workbookLuid', 'Required parameter requestParameters.workbookLuid was null or undefined when calling analyticsExtensionsServiceUpdateWorkbookWithConnection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.analyticsextensions.v1.ConnectionMapping+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/analytics/workbooks/{workbook_luid}/selected_connection`.replace(`{${"workbook_luid"}}`, encodeURIComponent(String(requestParameters.workbookLuid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauAnalyticsextensionsV1ConnectionMappingToJSON(requestParameters.tableauAnalyticsextensionsV1ConnectionMapping),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauAnalyticsextensionsV1ConnectionMappingFromJSON(jsonValue));
        });
    }
    /**
     * Updates the analytics extension connection to external service currently used by a workbook. Permissions - This method can be called by users that have permissions to the specified workbook.
     * Update analytics extension for workbook
     */
    analyticsExtensionsServiceUpdateWorkbookWithConnection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.analyticsExtensionsServiceUpdateWorkbookWithConnectionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Adds a dashboard extension to the block list of a server. Permissions - This method can only be called by server administrators. Availability - Not available for Tableau Online.
     * Block dashboard extension on server
     */
    dashboardExtensionsServerSettingsServiceCreateDashboardExtensionsBlockListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.extensions.dashboard.v1.BlockListItem+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/server/extensions/dashboard/blockListItems`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauExtensionsDashboardV1BlockListItemToJSON(requestParameters.tableauExtensionsDashboardV1BlockListItem),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtensionsDashboardV1BlockListItemFromJSON(jsonValue));
        });
    }
    /**
     * Adds a dashboard extension to the block list of a server. Permissions - This method can only be called by server administrators. Availability - Not available for Tableau Online.
     * Block dashboard extension on server
     */
    dashboardExtensionsServerSettingsServiceCreateDashboardExtensionsBlockListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardExtensionsServerSettingsServiceCreateDashboardExtensionsBlockListItemRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Deletes a specific extension from the block list of a server. Permissions - This method can only be called by server administrators. Availability - Not available for Tableau Online.
     * Unblock dashboard extension on server
     */
    dashboardExtensionsServerSettingsServiceDeleteDashboardExtensionsBlockListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.blockListItemLuid === null || requestParameters.blockListItemLuid === undefined) {
                throw new runtime.RequiredError('blockListItemLuid', 'Required parameter requestParameters.blockListItemLuid was null or undefined when calling dashboardExtensionsServerSettingsServiceDeleteDashboardExtensionsBlockListItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/server/extensions/dashboard/blockListItems/{block_list_item_luid}`.replace(`{${"block_list_item_luid"}}`, encodeURIComponent(String(requestParameters.blockListItemLuid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a specific extension from the block list of a server. Permissions - This method can only be called by server administrators. Availability - Not available for Tableau Online.
     * Unblock dashboard extension on server
     */
    dashboardExtensionsServerSettingsServiceDeleteDashboardExtensionsBlockListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.dashboardExtensionsServerSettingsServiceDeleteDashboardExtensionsBlockListItemRaw(requestParameters);
        });
    }
    /**
     * Gets the details of a specific dashboard extension on the blocked list of a server. Permissions - This method can only be called by server administrators. Availability - Not available for Tableau Online.
     * Get blocked dashboard extension on server
     */
    dashboardExtensionsServerSettingsServiceGetDashboardExtensionsBlockListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.blockListItemLuid === null || requestParameters.blockListItemLuid === undefined) {
                throw new runtime.RequiredError('blockListItemLuid', 'Required parameter requestParameters.blockListItemLuid was null or undefined when calling dashboardExtensionsServerSettingsServiceGetDashboardExtensionsBlockListItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/server/extensions/dashboard/blockListItems/{block_list_item_luid}`.replace(`{${"block_list_item_luid"}}`, encodeURIComponent(String(requestParameters.blockListItemLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtensionsDashboardV1BlockListItemFromJSON(jsonValue));
        });
    }
    /**
     * Gets the details of a specific dashboard extension on the blocked list of a server. Permissions - This method can only be called by server administrators. Availability - Not available for Tableau Online.
     * Get blocked dashboard extension on server
     */
    dashboardExtensionsServerSettingsServiceGetDashboardExtensionsBlockListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardExtensionsServerSettingsServiceGetDashboardExtensionsBlockListItemRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists the dashboard extensions on the blocked list of a server. Permissions - This method can only be called by server administrators. Availability - Not available for Tableau Online.
     * List blocked dashboard extensions on server
     */
    dashboardExtensionsServerSettingsServiceGetDashboardExtensionsBlockListItemsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/server/extensions/dashboard/blockListItems`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtensionsDashboardV1BlockListItemsFromJSON(jsonValue));
        });
    }
    /**
     * Lists the dashboard extensions on the blocked list of a server. Permissions - This method can only be called by server administrators. Availability - Not available for Tableau Online.
     * List blocked dashboard extensions on server
     */
    dashboardExtensionsServerSettingsServiceGetDashboardExtensionsBlockListItems(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardExtensionsServerSettingsServiceGetDashboardExtensionsBlockListItemsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists the dashboard extension settings of a server. Permissions - This method can only be called by server administrators. Availability - Not available for Tableau Online.
     * List settings for dashboard extensions on server
     */
    dashboardExtensionsServerSettingsServiceGetDashboardExtensionsServerSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/server/extensions/dashboard`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtensionsDashboardV1ServerSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Lists the dashboard extension settings of a server. Permissions - This method can only be called by server administrators. Availability - Not available for Tableau Online.
     * List settings for dashboard extensions on server
     */
    dashboardExtensionsServerSettingsServiceGetDashboardExtensionsServerSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardExtensionsServerSettingsServiceGetDashboardExtensionsServerSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Updates the settings for dashboard extensions of a server. Permissions - This method can only be called by server administrators.
     * Update settings for dashboard extensions on server
     */
    dashboardExtensionsServerSettingsServiceUpdateDashboardExtensionsServerSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.extensions.dashboard.v1.ServerSettings+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/server/extensions/dashboard`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauExtensionsDashboardV1ServerSettingsToJSON(requestParameters.tableauExtensionsDashboardV1ServerSettings),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtensionsDashboardV1ServerSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Updates the settings for dashboard extensions of a server. Permissions - This method can only be called by server administrators.
     * Update settings for dashboard extensions on server
     */
    dashboardExtensionsServerSettingsServiceUpdateDashboardExtensionsServerSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardExtensionsServerSettingsServiceUpdateDashboardExtensionsServerSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Adds a dashboard extension to the safe list of the site you are signed into. Permissions - This method can be called by site and server administrators.
     * Allow dashboard extension on site
     */
    dashboardExtensionsSiteSettingsServiceCreateDashboardExtensionsSafeListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.extensions.dashboard.v1.SafeListItem+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/dashboard/safeListItems`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauExtensionsDashboardV1SafeListItemToJSON(requestParameters.tableauExtensionsDashboardV1SafeListItem),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtensionsDashboardV1SafeListItemFromJSON(jsonValue));
        });
    }
    /**
     * Adds a dashboard extension to the safe list of the site you are signed into. Permissions - This method can be called by site and server administrators.
     * Allow dashboard extension on site
     */
    dashboardExtensionsSiteSettingsServiceCreateDashboardExtensionsSafeListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardExtensionsSiteSettingsServiceCreateDashboardExtensionsSafeListItemRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Deletes a specific dashboard extension from the safe list of the site you are signed into. Permissions - This method can be called by site and server administrators.
     * Disallow dashboard extension on site
     */
    dashboardExtensionsSiteSettingsServiceDeleteDashboardExtensionsSafeListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.safeListItemLuid === null || requestParameters.safeListItemLuid === undefined) {
                throw new runtime.RequiredError('safeListItemLuid', 'Required parameter requestParameters.safeListItemLuid was null or undefined when calling dashboardExtensionsSiteSettingsServiceDeleteDashboardExtensionsSafeListItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/dashboard/safeListItems/{safe_list_item_luid}`.replace(`{${"safe_list_item_luid"}}`, encodeURIComponent(String(requestParameters.safeListItemLuid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a specific dashboard extension from the safe list of the site you are signed into. Permissions - This method can be called by site and server administrators.
     * Disallow dashboard extension on site
     */
    dashboardExtensionsSiteSettingsServiceDeleteDashboardExtensionsSafeListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.dashboardExtensionsSiteSettingsServiceDeleteDashboardExtensionsSafeListItemRaw(requestParameters);
        });
    }
    /**
     * Gets the details of a specific dashboard extension on the safe list of the site you are signed into. Permissions - This method can be called by site and server administrators.
     * Get allowed dashboard extension on site
     */
    dashboardExtensionsSiteSettingsServiceGetDashboardExtensionsSafeListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.safeListItemLuid === null || requestParameters.safeListItemLuid === undefined) {
                throw new runtime.RequiredError('safeListItemLuid', 'Required parameter requestParameters.safeListItemLuid was null or undefined when calling dashboardExtensionsSiteSettingsServiceGetDashboardExtensionsSafeListItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/dashboard/safeListItems/{safe_list_item_luid}`.replace(`{${"safe_list_item_luid"}}`, encodeURIComponent(String(requestParameters.safeListItemLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtensionsDashboardV1SafeListItemFromJSON(jsonValue));
        });
    }
    /**
     * Gets the details of a specific dashboard extension on the safe list of the site you are signed into. Permissions - This method can be called by site and server administrators.
     * Get allowed dashboard extension on site
     */
    dashboardExtensionsSiteSettingsServiceGetDashboardExtensionsSafeListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardExtensionsSiteSettingsServiceGetDashboardExtensionsSafeListItemRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists the dashboard extensions on the safe list of the site you are signed into. Permissions - This method can be called by site and server administrators.
     * List allowed dashboard extensions on site
     */
    dashboardExtensionsSiteSettingsServiceGetDashboardExtensionsSafeListItemsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/dashboard/safeListItems`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtensionsDashboardV1SafeListItemsFromJSON(jsonValue));
        });
    }
    /**
     * Lists the dashboard extensions on the safe list of the site you are signed into. Permissions - This method can be called by site and server administrators.
     * List allowed dashboard extensions on site
     */
    dashboardExtensionsSiteSettingsServiceGetDashboardExtensionsSafeListItems(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardExtensionsSiteSettingsServiceGetDashboardExtensionsSafeListItemsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists the dashboard extension settings of the site you are signed into. Permissions - This method can be called by site and server administrators.
     * List settings for dashboard extensions on site
     */
    dashboardExtensionsSiteSettingsServiceGetDashboardExtensionsSiteSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/dashboard`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtensionsDashboardV1SiteSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Lists the dashboard extension settings of the site you are signed into. Permissions - This method can be called by site and server administrators.
     * List settings for dashboard extensions on site
     */
    dashboardExtensionsSiteSettingsServiceGetDashboardExtensionsSiteSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardExtensionsSiteSettingsServiceGetDashboardExtensionsSiteSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Updates the settings of a specific dashboard extension in the safe list of the site you are signed into. Permissions - This method can be called by site and server administrators.
     * Update settings for allowed dashboard extension on site
     */
    dashboardExtensionsSiteSettingsServiceUpdateDashboardExtensionsSafeListItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.safeListItemLuid === null || requestParameters.safeListItemLuid === undefined) {
                throw new runtime.RequiredError('safeListItemLuid', 'Required parameter requestParameters.safeListItemLuid was null or undefined when calling dashboardExtensionsSiteSettingsServiceUpdateDashboardExtensionsSafeListItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.extensions.dashboard.v1.SafeListItem+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/dashboard/safeListItems/{safe_list_item_luid}`.replace(`{${"safe_list_item_luid"}}`, encodeURIComponent(String(requestParameters.safeListItemLuid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauExtensionsDashboardV1SafeListItemToJSON(requestParameters.tableauExtensionsDashboardV1SafeListItem),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtensionsDashboardV1SafeListItemFromJSON(jsonValue));
        });
    }
    /**
     * Updates the settings of a specific dashboard extension in the safe list of the site you are signed into. Permissions - This method can be called by site and server administrators.
     * Update settings for allowed dashboard extension on site
     */
    dashboardExtensionsSiteSettingsServiceUpdateDashboardExtensionsSafeListItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardExtensionsSiteSettingsServiceUpdateDashboardExtensionsSafeListItemRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Updates the settings for dashboard extensions for the site you are signed into. Permissions - This method can be called by site and server administrators.
     * Update settings for dashboard extension on site
     */
    dashboardExtensionsSiteSettingsServiceUpdateDashboardExtensionsSiteSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.extensions.dashboard.v1.SiteSettings+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/settings/site/extensions/dashboard`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauExtensionsDashboardV1SiteSettingsToJSON(requestParameters.tableauExtensionsDashboardV1SiteSettings),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtensionsDashboardV1SiteSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Updates the settings for dashboard extensions for the site you are signed into. Permissions - This method can be called by site and server administrators.
     * Update settings for dashboard extension on site
     */
    dashboardExtensionsSiteSettingsServiceUpdateDashboardExtensionsSiteSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardExtensionsSiteSettingsServiceUpdateDashboardExtensionsSiteSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.SettingsApi = SettingsApi;
